/**
 * RESPONSIBILITY: the templates a block of the /adc page may be built from.
 *
 * THESE STRINGS ARE STORED. A saved block says which template it is by this text, so
 * renaming one silently blanks every block using it. Add freely; rename never.
 */
export const ADC_THEME = {
  Image: 'Image',
  Text: 'Text',
  ImageLeft: 'Image left, text right',
  ImageRight: 'Text left, image right',
  ImageTop: 'Image on top, text below',
  TextTop: 'Text on top, image below',
  Faq: 'Questions and answers',
  Video: 'Video',
  Gallery: 'Gallery',
} as const;

export const ADC_THEMES = Object.values(ADC_THEME);
